module.exports = __webpack_public_path__ + "static/media/verification.e1793748.svg";